module.exports = __webpack_public_path__ + "static/media/testImg.ad8aff8a.png";